import styled from "styled-components";
import { dispositivo } from "../../components/Dispositivos";

export const DivCharts = styled.div`
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
  @media ${dispositivo.tablet} {
    display: flex;
  }
`;

export const Contenedor = styled.div`
  background-color: #f8f9fa;
  padding: 20px;
  border-radius: 12px;
  width: 100%;
  box-sizing: border-box;
  border: 1px solid #e9ecef;
`;

export const Seccion = styled.div`
  width: 100%;
  margin-bottom: 2.5rem;
  &:last-child {
    margin-bottom: 0;
  }
`;

export const SeccionTitulo = styled.h2`
  font-size: 1.15rem;
  color: #0C234C;
  margin: 0 0 1.25rem 0;
  padding-bottom: 0.5rem;
  border-bottom: 3px solid #0c8de3;
  display: inline-block;
  font-weight: 600;
  letter-spacing: 0.5px;
  @media ${dispositivo.tablet} {
    font-size: 1.35rem;
  }
`;

export const GridTotales = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 1.25rem;
  width: 100%;
  @media ${dispositivo.tablet} {
    grid-template-columns: 1fr 1fr 1fr;
  }
`;

export const GridGraficos = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 1.5rem;
  width: 100%;
  @media ${dispositivo.tablet} {
    grid-template-columns: 1fr 1fr;
  }
`;

export const Titulo = styled.h1`
  display: flex;
  font-size: 0.95rem;
  font-weight: 600;
  color: #495057;
  justify-content: center;
  margin-bottom: 0.5rem;
  @media ${dispositivo.tablet} {
    font-size: 1.1rem;
  }
`;

export const Contenido = styled.div`
  display: flex;
  font-size: 1.5rem;
  font-weight: 700;
  color: #0C234C;
  justify-content: center;
  align-items: center;
  margin-bottom: 0.75rem;

  @media ${dispositivo.tablet} {
    font-size: 1.85rem;
  }
`;

export const Item = styled.div`
  width: 100%;
  background-color: #ffffff;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.03), 0 1px 3px rgba(0, 0, 0, 0.02);
  border: 1px solid #e9ecef;
  transition: transform 0.22s ease, box-shadow 0.22s ease;
  
  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.06);
  }
`;

export const GridFinanzasCards = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 1.25rem;
  width: 100%;
  margin-bottom: 1.5rem;
  @media ${dispositivo.tablet} {
    grid-template-columns: repeat(3, 1fr);
  }
  @media (min-width: 1200px) {
    grid-template-columns: repeat(5, 1fr);
  }
`;

